import { TableField, defaultDateTimeFormatter } from "../../table-field";

export const fieldsHistoricoLicitacao: TableField[] = [
  {
    key: "DtLog",
    label: "Data",
    tdClass: "align-middle naoQuebrar",
    thClass: "text-center naoQuebrar",
    sortable: true,
    formatter: defaultDateTimeFormatter,
  },
  {
    key: "NmUsuarioUltimaAlteracao",
    label: "Usuário responsável",
    tdClass: "align-middle quebrarPorPalavraHard",
    thClass: "text-center quebrarPorPalavraHard",
    sortable: true,
  },
  {
    key: "TipoLog",
    label: "Operação",
    tdClass: "align-middle quebrarPorPalavra",
    thClass: "text-center quebrarPorPalavra",
    sortable: true,
  },
];
